import { Select } from "@mui/material";
import styled from "styled-components";

export const LanguageStyled = styled(Select)`
  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding-top: 6px;
    padding-bottom: 6px;
  }
`;
